import Rule, {RuleLikeObject, RuleMatches} from "./Rule";

export enum Operator {
    AND = 'AND',
    OR = 'OR'
}

export type RuleGroupLikeObject = {
    operator: Operator,
    rules: Array<RuleLikeObject | RuleGroupLikeObject>
}

export default class RuleGroup implements RuleMatches {
    constructor(
        public readonly operator: Operator,
        public readonly rules: Array<Rule | RuleGroup>
    ) {
    }

    static fromObject(item: RuleGroupLikeObject): RuleGroup {
        return new RuleGroup(item.operator, item.rules.map(item => {
            if ("operator" in item) {
                return RuleGroup.fromObject(item)
            }
            return Rule.fromObject(item)
        }))
    }

    public getElementIds(): string[] {
        return this.rules.reduce((ids: string[], rule) => ids.concat(
            rule instanceof RuleGroup ? rule.getElementIds() : [rule.key]
        ), [])
    }

    public matches(form: JQuery<HTMLFormElement>): boolean {
        if (this.operator === Operator.OR) {
            return this.rules.some(rule => rule.matches(form))
        }

        return this.rules.every(rule => rule.matches(form))
    }
}
